import { render, staticRenderFns } from "./AdditionalMaterial.vue?vue&type=template&id=8949483e&scoped=true&"
import script from "./AdditionalMaterial.vue?vue&type=script&lang=js&"
export * from "./AdditionalMaterial.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalMaterial.vue?vue&type=style&index=0&id=8949483e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8949483e",
  null
  
)

export default component.exports